import styled from '@emotion/styled'

const Header = styled.h1`
  display: inline-block;
`

export default Header
